var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckInCircle = function SvgCheckInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48363 2 2 6.48363 2 12C2 17.5164 6.48363 22 12 22C17.5164 22 22 17.5164 22 12C22 6.48273 17.5164 2 12 2ZM12 3C16.9644 3 21 7.03534 21 12C21 16.9641 16.9641 21 12 21C7.03591 21 3 16.9641 3 12C3 7.03591 7.03591 3 12 3ZM9.6238 11.8283L10.8458 12.9673L14.3801 9.70873L14.4443 9.65688C14.5346 9.59469 14.6471 9.55893 14.8235 9.53336C14.9827 9.53336 15.1354 9.59105 15.2723 9.71308C15.5336 9.96647 15.5326 10.374 15.2612 10.6255L11.2804 14.2927C11.1569 14.4071 11.0012 14.4666 10.8392 14.4666C10.6757 14.4666 10.5244 14.4103 10.3953 14.2932L8.73098 12.7403C8.46663 12.4896 8.46663 12.0715 8.73793 11.8231C8.98971 11.595 9.37116 11.5942 9.6238 11.8283Z",
    fill: "currentColor"
  })));
};
export default SvgCheckInCircle;